import React, { useMemo } from 'react'
import { Notification as CPNotification } from '@usap/uicomponents'
import { useVehicleContext } from '../../contexts/vehicle.context'
import usePLAController from '../../controllers/pla.controller'
import { usePLAContext } from '../../contexts/pla.context'

export default function Notification() {
  const vehicleState = useVehicleContext()
  const { updatePLA } = usePLAController()

  const plaContext = usePLAContext()
  const { brand, part, sku } = useMemo(() => plaContext?.fromPDPPLA || {},
    [plaContext])

  const {
    engine, make, year, model, submodel,
  } = useMemo(() => vehicleState.vehicleDB?.find(element => element.selected) || {},
    [vehicleState.vehicleDB])

  const clearFromPDPPLA = () => {
    updatePLA({ fromPDPPLA: {} })
  }

  const showNotification = useMemo(
    () => Boolean(brand && part && sku && year),
    [year, brand, part, sku],
  )

  const notifyMessage = useMemo(
    () => `<div style="color:#f44635;font-size:14px">
        ${brand} ${part} ${sku} does not fit selected vehicle.
      </div>
      <div style="color:#2e4787;font-size:14px">
        Displaying similar parts that fit your 
        <span style="text-decoration:underline">
          ${year} ${make} ${model} ${submodel || ''} ${engine || ''}
        <span>
      </div>`,
    [
      engine,
      make,
      model,
      submodel,
      year,
      brand,
      part,
      sku,
    ],
  )

  return (
    showNotification && (
    <CPNotification
      type="info"
      message={notifyMessage}
      timeout={20000}
      cb={clearFromPDPPLA}
    />
    )
  )
}
